import { createReducer, on } from "@ngrx/store";
import * as ItemActions from "./item.actions";
import { initialItemState, ItemState } from "./item.state";
import {
  checkItemExists,
  checkItemExistsSuccess,
  checkItemExistsFailure
} from './item.actions';


export const itemReducer = createReducer(
  initialItemState,
  // Load Items
  on(ItemActions.loadItems, (state) => ({ ...state, loading: true })),
  on(ItemActions.loadItemsSuccess, (state, { items }) => ({
    ...state,
    items,
    loading: false,
    error: null,
  })),
  on(ItemActions.loadItemsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  //load single item by id
on(ItemActions.loadItem, (state) => ({
  ...state,
  loading: true,
  error: null,
})),

on(ItemActions.loadItemSuccess, (state, { item }) => ({
  ...state,
  selectedItem: item,
  loading: false,
})),

on(ItemActions.loadItemFailure, (state, { error }) => ({
  ...state,
  error,
  loading: false,
})),
  // Create Item
  on(ItemActions.createItem, (state) => ({ ...state, loading: true })),
  on(ItemActions.createItemSuccess, (state, { item }) => ({
    ...state,
    items: [...state.items, item],
    loading: false,
    error: null,
  })),
  on(ItemActions.createItemFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Update Item
  on(ItemActions.updateItem, (state) => ({ ...state, loading: true })),
  on(ItemActions.updateItemSuccess, (state, { item }) => ({
    ...state,
    items: state.items.map((i) => (i.id === item.id ? item : i)),
    loading: false,
    error: null,
  })),
  on(ItemActions.updateItemFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Delete Item
  on(ItemActions.deleteItem, (state) => ({ ...state, loading: true })),
  on(ItemActions.deleteItemSuccess, (state, { id }) => ({
    ...state,
    items: state.items.filter((i) => i.id !== id),
    loading: false,
    error: null,
  })),
  on(ItemActions.deleteItemFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(ItemActions.selectItem, (state, { item }) => ({
    ...state,
    selectedItem: item,
  })),

  on(ItemActions.clearSelectedItem, (state) => ({
    ...state,
    selectedItem: null,
  })),
  on(ItemActions.searchItems, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ItemActions.searchItemsSuccess, (state, { items, total, rowIndex }) => ({
    ...state,
    loading: false,
    searchResultsByRow: {
      ...state.searchResultsByRow,
      [rowIndex]: items,
    },
    total,
  })),
  on(ItemActions.searchItemsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ItemActions.clearItems, (state) => ({
    ...state,
    searchResultsByRow: {},
    total: 0,
  })),

  // Check if item exists by name
on(checkItemExists, (state) => ({
  ...state,
  checkingItemExists: true,
  itemExists: null,
  error: null,
})),

on(checkItemExistsSuccess, (state, { exists }) => ({
  ...state,
  checkingItemExists: false,
  itemExists: exists,
})),

on(checkItemExistsFailure, (state, { error }) => ({
  ...state,
  checkingItemExists: false,
  itemExists: null,
  error,
})),








);
